import queryConstructor from '@/components/query/query-constructor';

export type BuildInitialReportFiltersOptions = {
  routeData: unknown;
  groupBy: string;
  grouping: string | null | undefined;
  reportParams: Record<string, unknown>;
};

export const buildInitialReportFilters = (options: BuildInitialReportFiltersOptions) => {
  const query = JSON.parse(JSON.stringify(options.reportParams));

  if (!query.compareEnabled) {
    delete query.compareEnabled;
    delete query.compareFrom;
    delete query.compareTo;
    delete query.compareDate;
  }

  if (query.columns && options.grouping) {
    query.columns[0] = options.grouping;
  }

  query.groupBy = options.groupBy;

  const urlData = queryConstructor.decode(options.routeData) || {};
  const orphanParams = ['orderBy', 'orderDir', 'from', 'to', 'date', 'timezone'];

  orphanParams.forEach((param) => {
    if ((query[param] == null || query[param] === '') && urlData[param]) {
      query[param] = urlData[param];
    }
  });

  if (!query.from || !query.to) {
    const day = new Date().toISOString().slice(0, 10);
    query.from = query.from || `${day} 00:00:00`;
    query.to = query.to || `${day} 23:59:59`;
    query.date = query.date || 'today';
    query.timezone = query.timezone || 'UTC';
  }

  return query;
};

export type VerifyReportQueryOptions = {
  query: Record<string, unknown>;
  treeLevel: number;
  selectedMetrics: string[];
  removeTableColumnFilter: (filterHaving: string) => void;
};

export const verifyReportQuery = (options: VerifyReportQueryOptions) => {
  const query = options.query;

  options.selectedMetrics.forEach((column) => {
    const columns = (query.columns || []) as string[];
    if (columns.indexOf(column) === -1) {
      columns.push(column);
    }
    query.columns = columns;
  });

  const columns = (query.columns || []) as string[];

  if (options.treeLevel === 0) {
    if (query.filterHaving && (query.filterHaving as unknown[]).length) {
      for (const index in query.filterHaving as Record<string, unknown>) {
        const filterHaving = query.filterHaving as Record<string, unknown>;
        const filterHavingOptions = query.filterHavingOptions as Record<string, unknown>;
        const filterHavingValues = query.filterHavingValues as Record<string, unknown>;

        if (columns.indexOf(filterHaving[index] as string) === -1) {
          options.removeTableColumnFilter(filterHaving[index] as string);

          delete filterHaving[index];
          delete filterHavingOptions[index];
          delete filterHavingValues[index];
        }
      }
    }

    if (query.filterHaving && !(query.filterHaving as unknown[]).length) {
      delete query.filterHaving;
      delete query.filterHavingOptions;
      delete query.filterHavingValues;
    }
  } else {
    delete query.filterHaving;
    delete query.filterHavingOptions;
    delete query.filterHavingValues;
  }

  if (query.orderBy && columns.indexOf(query.orderBy as string) === -1) {
    query.orderBy = columns[columns.length - 1];
  }

  query.offset = query.offset || 0;
  return query;
};
